module.exports = {
  "wrapper": {
    "backgroundColor": "#ffffff",
    "boxShadow": "0 -1px 5px 0 rgba(0, 0, 0, 0.05)"
  },
  "top-border": {
    "borderTopStyle": "solid",
    "borderTopWidth": "1",
    "borderTopColor": "#e5e5e8"
  },
  "tab-bar-list": {
    "flexDirection": "row",
    "justifyContent": "space-around",
    "paddingTop": "12",
    "paddingRight": "10",
    "paddingBottom": "16",
    "paddingLeft": "10"
  },
  "mutil-tab-bar-container": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "mutil-tab-bar-item": {
    "alignItems": "center",
    "opacity": 1
  },
  "is-launch": {
    "height": "96",
    "borderRadius": "48",
    "backgroundColor": "#ffffff",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "is-launch-text": {
    "textAlign": "center",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "32",
    "color": "#ffffff"
  },
  "tab-bar-item": {
    "alignItems": "center",
    "opacity": 1
  },
  "tab-bar-item-disabled": {
    "opacity": 0.3
  },
  "icon-wrapper": {
    "flex": 1
  },
  "mutil-icon-wrapper": {
    "width": "110"
  },
  "icon-container": {
    "height": "110",
    "borderRadius": "55",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#ffffff",
    "position": "relative"
  },
  "dot-triangle": {
    "position": "absolute",
    "right": "7",
    "top": "83",
    "width": "20",
    "height": "18"
  },
  "icon-inner-container": {
    "height": "96",
    "borderRadius": "48",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "relative",
    "overflow": "hidden"
  },
  "mask": {
    "position": "absolute",
    "top": "7",
    "left": "7",
    "height": "96",
    "borderRadius": "48",
    "backgroundColor:active": "rgba(255,255,255,0.1)"
  },
  "animate-circle": {
    "position": "absolute",
    "height": "94",
    "borderRadius": "47",
    "backgroundColor": "#e5e5e8"
  },
  "tab-bar-item-icon": {
    "width": "96",
    "height": "96"
  },
  "tab-bar-item-loading": {
    "width": "48",
    "height": "48"
  },
  "tab-bar-item-icon-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "28",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "28"
  },
  "tab-bar-item-title": {
    "paddingTop": "9"
  },
  "tab-bar-item-title-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#1e2e37",
    "letterSpacing": 0,
    "textAlign": "center",
    "fontSize": "24"
  },
  "line-wrapper": {
    "height": "68",
    "flexDirection": "row",
    "justifyContent": "center",
    "backgroundColor": "#ffffff"
  },
  "line": {
    "width": "268",
    "height": "10",
    "backgroundColor": "#1e2e37",
    "opacity": 0.1,
    "borderRadius": "5",
    "marginTop": "42"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2379436c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-bottom-bar/index.vue
// module id = 440
// module chunks = 0 1